import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-gif-prompt',
  templateUrl: './gif-prompt.page.html',
  styleUrls: ['./gif-prompt.page.scss']
})
export class GifPromptPage implements OnInit {

  src: string;
  id: string;

  constructor(private _viewCtrl: ModalController, private _params: NavParams) {
    this.src = this._params.get('src');
    this.id = this._params.get('dec');
  }

  ngOnInit() {
    const elem = document.querySelector('ion-backdrop') as HTMLElement;
    elem.style.cssText = 'background-color: none !important;';
  }

  goBack() {
    this._viewCtrl.dismiss();
  }

}

